// extracted by mini-css-extract-plugin
export default {"groove":"toggler_groove__vaWXq","slider":"toggler_slider__udzCo","toggle_on":"toggler_toggle_on__h1wUc","groove_toggle_on":"toggler_groove_toggle_on__xk1jS"};